import React from 'react';
import CasePermanentMedicationOptionsContextMenu, {
	PermanentMedicationContextMenuTriggerType,
} from '../../../Case/Components/CasePermanentMedicationOptionsContextMenu/CasePermanentMedicationOptionsContextMenu';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import Tooltip from '../../../../Components/Popup/Tooltip';
import { MonitoringCenterCase } from '../MonitoringCenterListTable/MonitoringCenterListTable';
import useCaseConnect from '../../../Case/Hooks/useCaseConnect';

interface Props {
	item: MonitoringCenterCase;
	onRefresh: () => void;
}

const MonitoringCenterControlsColumn: React.FC<Props> = ({
	item,
	onRefresh,
}) => {
	const { handleAssignCase } = useCaseConnect();

	const isDisabled = !item.isNew && !item.isMyCase;
	const isConnectEnable =
		item.totalUnreadCaseEntries && item.totalUnreadCaseEntries > 0;

	if (item.caseType?.code === 'permanent_medication' && item.medicationLasted) {
		return (
			<CasePermanentMedicationOptionsContextMenu
				patientId={item.patient.id}
				caseId={item.id}
				medications={item.medicationLasted?.map(item => item.medicationId)}
				reloadCaseList={onRefresh}
				triggerType={PermanentMedicationContextMenuTriggerType.BUTTON}
			/>
		);
	}

	if (isDisabled) {
		return (
			<Tooltip
				trigger={
					<Button
						title='component.monitoringCenter.tookOver'
						theme={Theme.DISABLED}
						small
					/>
				}
				position='bottom center'>
				{item.assignedDoctorShortedName}
			</Tooltip>
		);
	}

	return (
		<Button
			title={
				item.isMyCase && item.isAssigned
					? 'component.monitoringCenter.continue'
					: 'component.monitoringCenter.connect'
			}
			theme={Theme.GREEN}
			badge={
				isConnectEnable ? item.totalUnreadCaseEntries?.toString() : undefined
			}
			onClick={() => handleAssignCase(item.id)}
			small
		/>
	);
};

export default MonitoringCenterControlsColumn;
